import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    console.log("INDEX_DEBUG index controller connected")
  }
}
